const ROLES = {
  ADMIN: "ADMIN",
  MANAGER: "MANAGER",
  MARKETING: "MARKETING",
  SAC: "SAC",
  SUPPORT: "SUPPORT",
  SHOPKEEPER: "SHOPKEEPER",
};

export default ROLES;
